import React from 'react';
import type { PoseGuideId } from '../../types/engagement';

/**
 * Semi-transparent line reference for a challenge photo. Purely visual:
 * it never reads, analyses or scores the camera image.
 */
export function PoseGuideOverlay({
  pose,
  opacity
}: {
  pose: PoseGuideId;
  opacity: number;
}) {
  return <svg viewBox="0 0 120 160" className="pointer-events-none absolute inset-0 h-full w-full" style={{
    opacity
  }} fill="none" stroke="#F5F1E6" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-711" data-mp="3trhz5u4l40ch">
      {pose === 'tree' ? <>
          <circle cx="60" cy="30" r="8" data-id="element-712" data-mp="3602s5o1v4uuw" />
          <path d="M60 38 V92" data-id="element-713" data-mp="3asccmok7l2ps" />
          <path d="M60 50 L47 26 L60 9 L73 26 Z" data-id="element-714" data-mp="3asm3eed2vdwj" />
          <path d="M60 92 V150 H68" data-id="element-715" data-mp="3augobsocn60m" />
          <path d="M60 92 L82 112 L63 118" data-id="element-716" data-mp="2eazkdyarp2di" />
        </> : <>
          <path d="M14 141 H108" strokeDasharray="2 4" data-id="element-717" data-mp="2ic1lkko8voi4" />
          <circle cx="52" cy="58" r="8" data-id="element-718" data-mp="2iai8f2xvxtkk" />
          <path d="M52 66 L55 120" data-id="element-719" data-mp="3pfm35iiictz8" />
          <path d="M53 80 L41 138" data-id="element-720" data-mp="3peu9id8h16bl" />
          <path d="M53 80 L66 138" data-id="element-721" data-mp="3phyg1h9ese5f" />
          <path d="M55 120 L30 135 L70 138" data-id="element-722" data-mp="3kg96k61u48jg" />
          <path d="M55 120 L110 138" data-id="element-723" data-mp="3khkkgyozuwoa" />
        </>}
    </svg>;
}